import React, { useCallback, useState } from "react";
import { AHIcon, AHText, Box, Input } from "arkh";

import { FormattedMessage, useIntl } from "react-intl";
import { graphql, useMutation } from "react-relay";
import { AddScreenSetNameMutation } from "./__generated__/AddScreenSetNameMutation.graphql";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";

import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";

export function AddScreenSetName(
  props: StoreAdminNavigationScreenProps<"AddScreenSetName">
) {
  const intl = useIntl();

  const [name, setName] = useState("");

  const [saveName, loadingSave] = useMutation<AddScreenSetNameMutation>(graphql`
    mutation AddScreenSetNameMutation($screenId: ID!, $name: String!) {
      storecast {
        setScreenName(screenId: $screenId, name: $name) {
          id
        }
      }
    }
  `);

  const onSaveName = useCallback(() => {
    saveName({
      variables: { name, screenId: props.route.params.screenId },
      onCompleted: () => {
        props.navigation.replace("AddScreenInfo", props.route.params);
      },
    });
  }, [name, props.navigation, props.route.params, saveName]);

  useNavigationHeader({
    type: "SAVE",
    onCancel: () => props.navigation.goBack(),
    onSave: onSaveName,
    saveLoading: loadingSave,
  });
  return (
    <>
      <Box spaceVertical="xlarge" spaceHorizontal="large" style={{ flex: 1 }}>
        <Box spaceBottom="xsmall" style={{ alignItems: "center" }}>
          <AHIcon type="tv" size="xlarge" />
        </Box>
        <AHText type="title-big" spaceBottom="large" textAlign="center">
          <FormattedMessage
            description="Storecast admin add screen set name title"
            defaultMessage="Name screen"
          />
        </AHText>
        <Input
          autoFocus
          style={[
            {
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
          ]}
          autoCapitalize="sentences"
          placeholder={intl.formatMessage({
            defaultMessage: "Name",
            description: "StorecastAdminAddTVConfigure name input placeholder",
          })}
          submitBehavior="blurAndSubmit"
          onSubmitEditing={() => {
            onSaveName();
          }}
          value={name}
          onChangeText={setName}
        />
      </Box>
    </>
  );
}
